import ContactButton from '@/components/ContactButton';

interface PaywallProps {
  isPaid?: boolean;
  handleCtaClick: () => void;
}

function Paywall({ handleCtaClick, isPaid = false }: PaywallProps) {
  return (
    <div
      data-cy='create-account-modal'
      className={`print:hidden px-4 bg-[url(/cta-banner-background.svg)] bg-no-repeat bg-cover my-12 mb-0 py-9 bg-[#002327] rounded-lg text-white text-center ${isPaid ? '-mt-4' : 'mt-0'}`}
    >
      <p className='leading-tight tracking-tight text-[1.6rem] font-bold mb-4'>
        Access Premium Market Analysis & Indicators
      </p>
      <ul className='w-full mx-auto items-center flex flex-col gap-1 [&>li]:w-full'>
        <li>&bull;&nbsp; Energy: Gas, LNG & Oil market intelligence</li>
        <li>&bull;&nbsp; Fundamental & quantitative analysis</li>
      </ul>

      <ContactButton className='mx-auto mt-5' />

      <button
        onClick={handleCtaClick}
        className='mt-3 mx-auto text-sm text-teal-400 hover:underline block cursor-pointer'
      >
        Already have an account? <span className='font-bold'>Login</span>
      </button>
    </div>
  );
}

export default Paywall;
